import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsFetching } from '@tanstack/react-query';
import { MenuToggle } from '@/components/MenuToggle';
import { QueryKey } from '@/constants';
import { getLinksDataFromNodeList } from '@/utils/getLinksDataFromNodeList';

const menuTogglePortal = document.querySelector('.header__main__toggle');

const authLinkQuery = '.header__utility__authentication .auth-links li';

export const useMenuToggle = () => {
  const isFetchingAuthStatus = useIsFetching({
    queryKey: [QueryKey.CustomerStatus],
  });

  const [authLinkNodes, setAuthLinkNodes] = useState<NodeListOf<Element>>(
    document.querySelectorAll(authLinkQuery),
  );

  const productLinkNodes: NodeListOf<Element> = document.querySelectorAll(
    '.header__navigation .navigation__list__item',
  );

  const utilityLinkNodes: NodeListOf<Element> = document.querySelectorAll(
    '.header__utility__content .navigation li',
  );

  const authLinks = getLinksDataFromNodeList(authLinkNodes);

  const productLinks = getLinksDataFromNodeList(productLinkNodes);

  const utilityLinks = getLinksDataFromNodeList(utilityLinkNodes);

  useEffect(() => {
    if (!isFetchingAuthStatus) {
      setAuthLinkNodes(document.querySelectorAll(authLinkQuery));
    }
  }, [isFetchingAuthStatus]);

  return menuTogglePortal && !isFetchingAuthStatus
    ? createPortal(
        <MenuToggle
          productLinks={productLinks}
          utilityLinks={[...authLinks, ...utilityLinks]}
        />,
        menuTogglePortal,
      )
    : null;
};
